import _cloneDeep from 'lodash/cloneDeep';

export const getEmptySelectionSet = (): SelectionSet =>
    _cloneDeep({
        selectedIds: [] as string[],
        selectableViews: [] as TrqkStatementView[],
        label: {
            long: '',
            short: '',
        },
        presets: {
            all: {
                ids: [] as string[],
                label: {
                    long: '',
                    short: '',
                },
            },
            lastTwo: {
                ids: [] as string[],
                label: {
                    long: '',
                    short: '',
                },
            },
            yearToDate: {
                ids: [] as string[],
                label: {
                    long: '',
                    short: '',
                },
            },
        },
    });
